import React from 'react';
import './Footer.scss'; // Ensure this path is correct

const Footer = () => {
  return (
    <div className="footer-container">
      <div className="footer-copyright">
        Copyright © 2024
      </div>
    </div>
  );
}

export default Footer;
